import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Formik, useFormik, Field, Form, FieldArray } from "formik";
import * as YUP from "yup";
import { InputText } from "primereact/inputtext";
import "primeflex/primeflex.css";
import { Toast } from "primereact/toast";
import styles from "../Projects/AddProject.module.css";
import { RadioButton } from "primereact/radiobutton";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";
import { AutoComplete } from "primereact/autocomplete";
import { Chips } from "primereact/chips";
import { useDispatch, useSelector } from "react-redux";
import {
  addEmployeeDetails,
  allUsers,
  fetchAllEmployees,
  getEmployeeById,
  updateEmployeeDetails,
} from "../../../services/employeeService";
import Spinner from "../../../components/Spinner/spinner";
import { projectList } from "../../../services/projectService";
import { fetchEmployeeList } from "../../../store/slices/employeeListSlice";
import { appInsights } from "../../../AppInsights";

const employeeDetails = {
  firstName: "",
  lastName: "",
  email: "",
  managerId: "",
  location: "",
  phoneNumber: "",
  address: "",
  userProjectMapping: [
    { userTypeId: "", roleId: "", periodTypeId: "", projectIds: [] },
  ],
};

const projectTypes = [
  { name: "Add Internal Project", key: 1 },
  { name: "Add External Project", key: 2 },
];

const roles = [
  { name: "Accounts", id: 3 },
  { name: "Employee", id: 5 },
  { name: "HR", id: 2 },
  { name: "Manager", id: 4 },
  { name: "Super Admin", id: 1 },
];

export const AddEmployee = (props) => {
  const { userData } = useSelector((state) => state?.user);
 
  const currentUserTypeId = localStorage.getItem("userTypeId");
  const dispatch = useDispatch();
  const [internalProjects, setInternalProjects] = useState([]);
  const [externalProjects, setExternalProjects] = useState([]);
  const [employeeFilter, setEmployeeFilter] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = React.useRef(null);
  const options = [
    { label: "Weekly", key: 1 },
    { label: "Bi-Weekly", key: 2 },
    { label: "Monthly", key: 3 },
  ];
  const currentUserRoleId = userData?.userTypes?.find(
    (type) => type?.userTypeId == currentUserTypeId
  );

const roleId = currentUserRoleId?.userTypeRoleId
  const location = [
    { label: "India", value: "India" },
    { label: "USA", value: "USA" },
    { label: "Canada", value: "Canada" },
  ];
  const [selectedProjectsMap, setSelectedProjectsMap] = React.useState({});
  const [projectChipsMap, setProjectChipsMap] = React.useState({});
  const [users, setUsers] = useState([]);
  const validationForForm = YUP.object({
    firstName: YUP.string()
      .required("First name is Required")
      .min(2, "Employee Name must be at least 2 characters")
      .max(50, "Employee Name must be at most 50 characters"),
    lastName: YUP.string()
      .required("Last name is Required")
      .min(2, "Employee Name must be at least 2 characters")
      .max(50, "Employee Name must be at most 50 characters"),
    email: YUP.string()
      .required("Email is Required")
      .email("Please enter a valid email address"),
    managerId: YUP.string().nullable(),
    location: YUP.string().required("Location is Required"),
    // .required("Phone number is required")
    phoneNumber: YUP.string()
      .nullable()
      .matches(/^[0-9]{10}$/, "Phone number must be 10 digits"),
    address: YUP.string().nullable(),

    userProjectMapping: YUP.array()
      .of(
        YUP.object({
          userTypeId: YUP.string().nullable(),
          roleId: YUP.string().test(
            "conditional-required",
            "Role is required for selected project type",
            function (value) {
              if (this.parent.userTypeId) {
                return !!value;
              }
              return true;
            }
          ),
          periodTypeId: YUP.number().nullable(),
          projectIds: YUP.array()
            .test(
              "conditional-required",
              "At least one project must be selected for selected project type",
              function (value) {
                if (
                  this.parent.userTypeId &&
                  ![1, 2, 3].includes(Number(this.parent.roleId))
                ) {
                  return Array.isArray(value) && value.length > 0;
                }
                return true;
              }
            )
            .default([]),
        })
      )
      .test(
        "at-least-one-selected",
        "At least one project type must be selected",
        (value) => {
          return value && value.some((item) => item.userTypeId);
        }
      )
      .default([]),
  });

  const getInternalProjects = async () => {
    try {
      let result = await projectList(currentUserTypeId, 1);
      setInternalProjects(result);
    } catch (error) {
      appInsights.trackException("Get Addemployee", { exception: error });
    }
  };

  const getExternalProjects = async () => {
    try {
      let result = await projectList(currentUserTypeId, 2);
      setExternalProjects(result);
    } catch (error) {
      appInsights.trackException("Get Addemployee", { exception: error });
    }
  };
  const prepopulateEmployeeDetails = (data) => {
    setLoading(false);
    if (!data) return;
    // Initialize empty array for project mappings based on projectTypes length
    const initialProjectMappings = projectTypes.map(() => ({
      userTypeId: "",
      roleId: "",
      periodTypeId: "",
      projectIds: [],
    }));
    // Set up project chips map
    const newProjectChipsMap = {};
    // Populate project mappings based on data
    data.userProjects.forEach((mapping) => {
      // Find the index in projectTypes that matches this userTypeId
      const typeIndex = projectTypes.findIndex(
        (type) => type.key === mapping?.projectTypeId
      );
      if (typeIndex !== -1) {
        // Set the userTypeId to trigger checkbox
        // Extract just the project IDs for formik state
        const projectIds =
          mapping?.projects
            ?.map((project) => project?.projectId)
            .filter(Boolean) || [];

        initialProjectMappings[typeIndex] = {
          userTypeId: mapping.projectTypeId,
          roleId: mapping?.roleId,
          periodTypeId: mapping?.periodTypeId ? mapping?.periodTypeId : null,
          projectIds: projectIds,
        };

        // Store project chips for this mapping
        if (mapping?.projects && mapping?.projects.length > 0) {
          // Transform projectIds to match the expected format for chips
          newProjectChipsMap[typeIndex] = mapping.projects
            .map((project) => ({
              projectId: project?.projectId,
              name: project?.name,
            }))
            .filter((project) => project?.projectId && project?.name); // Filter out invalid projects
        }
      }
    });
    // Update project chips map all at once
    setProjectChipsMap(newProjectChipsMap);
    // Set selected projects map (empty string for dropdown initial state)
    const newSelectedProjectsMap = {};
    Object.keys(newProjectChipsMap).forEach((index) => {
      newSelectedProjectsMap[index] = "";
    });
    setSelectedProjectsMap(newSelectedProjectsMap);

    // Set form values
    formik.setValues({
      firstName: data.firstName || "",
      lastName: data.lastName || "",
      email: data.email || "",
      managerId: data.managerId || null,
      location: data.location || "",
      phoneNumber: data.phoneNumber || "",
      address: data.address || "",
      userProjectMapping: initialProjectMappings,
    });
  };

  useEffect(() => {
    fetchAlluser();
    getInternalProjects();
    getExternalProjects();
    if (!isNaN(Number(id))) {
      setLoading(true);
      if (!data) {
        fetchEmployeeById(currentUserTypeId, id);
      } else {
        prepopulateEmployeeDetails(data);
      }
    }
  }, []);

  const fetchAlluser = async () => {
    try {
      let result = await allUsers();
      const uniqueArray = new Set();
      let uniqueEmp = result
        ?.map((emp) => {
          // Check if the userId is not already in the uniqueArray set
          if (!uniqueArray.has(emp?.userId)) {
            uniqueArray.add(emp?.userId); // Use 'add' to add userId to the Set
            return { id: emp?.userId, name: emp?.userName }; // Return the unique employee object
          }
          return null; // If userId is already present, return null
        })
        .filter((emp) => emp !== null);
        const defaultOption = [{ id:null, name: 'Select a Manager' }];

        setUsers([...defaultOption, ...uniqueEmp]);
    } catch (error) {
      appInsights.trackException("Get AddEmployee", { exception: error });
    }
  };

  const fetchEmployeeById = async () => {
    try {
      let result = await getEmployeeById(currentUserTypeId, id);
      if (result) {
        setLoading(false);
        setData(result);
        prepopulateEmployeeDetails(result);
      } else {
        setLoading(false);
        //TODO:toast
      }
    } catch (error) {
      setLoading(false);
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail:   error?.message || error?.status == 400
        ? "User not Found"
        : error?.status == 500
        ? "Internal Server Error"
        : error?.status ==404?"User not Found":"Error occurred while fetching details",
        life: 5000,
      });
      appInsights.trackException("Get AddEmployee", { exception: error });
    }
  };
  const submitEmployeeData = async (values) => {
    try {
      setLoading(true);
      let result;

      // Prepare the form data
      const formData = {
        ...values,
        managerId: values.managerId === "" ? null : values.managerId,
        userProjectMapping: values?.userProjectMapping
          .filter((mapping) => {
            return mapping?.userTypeId;
          })
          .map((mapping) => {
            const projectIds = mapping.projectIds || [];
            return {
              userTypeId: mapping.userTypeId,
              roleId: mapping?.roleId,
              periodTypeId: mapping?.periodTypeId ? mapping.periodTypeId : null,
              projectIds: projectIds, // Already an array of IDs
            };
          }),
      };
      if (!data) {
        result = await addEmployeeDetails(currentUserTypeId, formData);
        formik?.resetForm();
        // TODO: move to employee list
      } else {
        result = await updateEmployeeDetails(
          currentUserTypeId,
          formData,
          data?.userId
        );
      }

      toast?.current?.show({
        severity: "success",
        summary: "Successful",
        detail: `${result}`,
        life: 3000,
      });

      // navigate("/timesheet-list");
      await dispatch(fetchEmployeeList(currentUserTypeId));
      setTimeout(() => {
        roleId==2?navigate(`/hr/employee-list`): navigate("/admin/employee-list");
      }, 500);

      setLoading(false);
    } catch (error) {
      appInsights.trackException("Post/Update Add Employee", {
        exception: error,
      });
      setLoading(false);
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message ? error?.message:
          error?.status === 400
            ? "User not Found"
            : error?.status === 500
            ? "Internal Server Error"
            : error?.status === 404
            ? "User not Found"
            : "Error occurred while submitting details",
        life: 5000,
      });
    } finally {
    }
  };
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      managerId: "",
      location: "",
      phoneNumber: "",
      address: "",
      userProjectMapping: projectTypes.map((type) => ({
        userTypeId: "",
        roleId: "",
        periodTypeId: "",
        projectIds: [], // This will store only project IDs
      })),
    },
    validationSchema: validationForForm,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values) => {
      submitEmployeeData(values);
    },
  });

  const revertSelectedProject = (projectId, index) => {
    // Remove the chip and update formik
    setProjectChipsMap((prev) => {
      const currentChips = prev[index] || [];
      const newChips = currentChips.filter(
        (project) => project?.projectId !== projectId
      );
      // Update formik with just the project IDs
      const updatedIds = newChips.map((chip) => chip.projectId);
      formik.setFieldValue(
        `userProjectMapping[${index}].projectIds`,
        updatedIds
      );

      return { ...prev, [index]: newChips };
    });

    // Clear the dropdown selection for this index
    setSelectedProjectsMap((prev) => ({
      ...prev,
      [index]: "",
    }));
  };

  const handleProjectSelect = (project, index) => {
    if (!project || !project?.projectId || !project.name) {
      return;
    }

    // Only check for duplicates within the same index
    const currentChips = projectChipsMap[index] || [];

    const isDuplicateInCurrentIndex = currentChips.some(
      (p) => p?.projectId === project.projectId
    );
    if (isDuplicateInCurrentIndex) {
      return;
    }

    // Create new chip
    const newChip = {
      projectId: project?.projectId,
      name: project?.name,
    };

    // Get current formik values for this mapping
    const currentFormikValue = formik.values.userProjectMapping[index] || {};
    const currentProjectIds = currentFormikValue.projectIds || [];

    // Update project chips map and formik state
    setProjectChipsMap((prev) => {
      const updatedChips = [...(prev[index] || []), newChip];
      // Add the new project ID to existing IDs
      const updatedProjectIds = [...currentProjectIds, project?.projectId];
      formik.setFieldValue(
        `userProjectMapping[${index}].projectIds`,
        updatedProjectIds
      );
      return { ...prev, [index]: updatedChips };
    });

    // Clear the dropdown selection
    setSelectedProjectsMap((prev) => ({
      ...prev,
      [index]: "",
    }));
  };

  const renderChips = (index) => {
    const currentChips = projectChipsMap[index] || [];
    if (!Array.isArray(currentChips)) {
      return null;
    }

    // Filter out any project that doesn't have a valid 'projectId'
    const validChips = currentChips?.filter(
      (project) => project && project?.projectId && project?.name
    );
    return validChips?.length > 0 ? (
      <div className="flex flex-wrap gap-2 mt-2">
        {validChips?.map((project) => {
          return (
            <div
              key={project?.projectId}
              className="flex align-items-center surface-100 border-round-2xl pl-3 pr-3 p-2"
            >
              <span className="mr-2 text-blue-900">{project?.name}</span>
              <i
                className="pi pi-times cursor-pointer"
                onClick={() => revertSelectedProject(project?.projectId, index)}
              />
            </div>
          );
        })}
      </div>
    ) : null;
  };

  const renderProjectDetails = (form, name, index) => {
    return (
      <div className="project-container pt-3">
        <div className="grid">
          <div className="col-12 md:col-6">
            <div className="pb-2">
              {" "}
              <label
                htmlFor="Role"
                className="text-600 font-semibold pb-3  mb-2"
              >
                Role<span className="pl-2 text-red-500">*</span>
              </label>
            </div>

            <Dropdown
              name={`userProjectMapping[${index}].roleId`}
              value={roles.find((user) => user.id === form?.roleId)}
              onChange={(e) => {
                formik.setFieldValue(
                  `userProjectMapping[${index}].roleId`,
                  e.value.id
                ); // Set only the `name` field
              }}
              options={roles}
              optionLabel="name"
              placeholder="Select Role"
              className="col-12 p-0"
              // onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.errors.userProjectMapping?.[index]?.roleId &&
              formik.touched.userProjectMapping?.[index]?.roleId && (
                <div className="text-red-500 pt-1">
                  <small>
                    {formik.errors.userProjectMapping[index].roleId}
                  </small>
                </div>
              )}
          </div>
          <div className="col-12 md:col-6">
            <div className="pb-2">
              <label
                htmlFor="period"
                className="text-600 font-semibold pb-3  mb-2"
              >
                Period Type
              </label>
            </div>
            <Dropdown
              name={`userProjectMapping[${index}].periodTypeId`}
              value={options.find((user) => user.key === form?.periodTypeId)}
              onChange={(e) => {
                formik.setFieldValue(
                  `userProjectMapping[${index}].periodTypeId`,
                  e.value.key
                ); // Set only the `name` field
              }}
              onBlur={formik?.handleBlur}
              options={options}
              optionLabel="label"
              placeholder="Period Type"
              className="col-12 p-0"
            />
          </div>
        </div>

        <div className="project-name-container col-12 w-100 pt-2 p-2">
          <div className="grid w-100  flex mt-1 bg-white border-300  px-3 border-round-xl border-1 ">
            <div className="project-names col-12 p-2">
              <span>
                <h2 className="project_name_title font-medium">{name}</h2>{" "}
                <div className="pb-2">
                  {" "}
                  <label
                    htmlFor="Project"
                    className="text-600 font-semibold pb-2  mb-2"
                  >
                    Project Names{" "}
                    {[4, 5].includes(Number(form.roleId)) && (
                      <span className="pl-2 text-red-500">*</span>
                    )}
                  </label>
                </div>
              </span>

              <Dropdown
                value={selectedProjectsMap[index] || ""}
                options={(index === 0
                  ? internalProjects
                  : index === 1
                  ? externalProjects
                  : []
                ).filter((project) => {
                  // Get current chips for this index
                  const currentChips = projectChipsMap[index] || [];
                  // Check if project is already selected in current index
                  const isSelectedInCurrentIndex = currentChips.some(
                    (chip) => chip.projectId === project.projectId
                  );
                  return !isSelectedInCurrentIndex;
                })}
                optionLabel="name"
                className={`col-12 p-0  ${styles?.autoComplete}`}
                onChange={(e) => {
                  const newValue = e.value;
                  // Only proceed if we have a valid selection
                  if (
                    newValue &&
                    typeof newValue === "object" &&
                    newValue.projectId
                  ) {
                    handleProjectSelect(newValue, index);
                  }

                  setSelectedProjectsMap((prev) => ({
                    ...prev,
                    [index]: newValue,
                  }));
                }}
                filter
                showClear
                filterBy="name"
                placeholder="Search Project Name...."
                virtualScrollerOptions={{ itemSize: 38 }}
              />

              {formik.errors.userProjectMapping?.[index]?.projectIds &&
                formik.touched.userProjectMapping?.[index]?.projectIds && (
                  <div className="text-red-500 pt-1">
                    <small>
                      {formik.errors.userProjectMapping[index].projectIds}
                    </small>
                  </div>
                )}
              <div className="col-12">{renderChips(index)}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleClear = () => {
    formik.resetForm();
    // setSelectedUserTypes([]);
    setProjectChipsMap({}); // Clear all project chips
    setSelectedProjectsMap({});
  };

  return (
    <React.Fragment>
      {loading && <Spinner />}
      <Toast ref={toast} position="top-center" />
      {!loading && (
        <form onSubmit={formik.handleSubmit}>
          <div className="container w-100 mt-1">
            <div className="bg-white p-2 border-round-xl col-12 w-100 ">
              <div className="section-for-title px-3 ">
                <span>
                  <Button
                    icon="pi pi-arrow-left"
                    label="Employee List"
                    className={`${styles.btnProject}`}
                    onClick={() =>  roleId==2?navigate(`/hr/employee-list`):navigate("/admin/employee-list")}
                  />
                </span>
                <div className="pt-3 md:flex px-3 justify-content-between">
                  <div className="Start pt-1">
                    {" "}
                    <h2 className="employee_header text-black-alpha-90 font-medium m-0 pl-2 pr-3 p-1">
                      {!data ? "Create Employee" : "Update Employee"}
                    </h2>
                  </div>
                  <div className="end flex md:justify-content-end">
                    <span className="btn-cancel p-1">
                      <Button
                        label="Clear"
                        className="border-round-xl bg-white border-300 text-color-secondary"
                        onClick={handleClear}
                      />
                    </span>
                    <span className="btn-create p-1">
                      <Button
                        label={`${
                          !data ? "Create Employee" : "Update Employee"
                        }`}
                        className="border-300"
                        style={{ background: "#0e2354" }}
                        type="submit"
                        onClick={(e) => {
                          e.preventDefault();
                          submitEmployeeData(formik.values, data);
                        }}
                        disabled={!formik?.isValid}
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="p-3 add-project">
            <div className="grid w-100  flex mt-1 bg-white   border-round-xl ">
              <div className="col-12 w-100 border-bottom-1  border-300">
                <span className="p-1 px-3">
                  <h2 className=" font-medium text-black-alpha-90 m-0 pl-3 pr-3 ">
                    Employee Details
                  </h2>
                </span>
              </div>
              <div className="col-12 w-100">
                <div className="form-for-add-project p-4">
                  <div className="grid">
                    <div className="col-12 md:col-6">
                      <label
                        htmlFor="Full Name"
                        className="text-600 font-semibold block mb-2"
                      >
                        First Name <span className="pl-2 text-red-500">*</span>
                      </label>
                      <InputText
                        id="name"
                        name="firstName"
                        value={formik.values.firstName}
                        placeholder="First Name"
                        className={styles.inputField1}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.firstName && formik.touched.firstName && (
                        <small className="text-red-500 block pt-1">
                          {formik.errors.firstName}
                        </small>
                      )}
                    </div>
                    <div className="col-12 md:col-6">
                      <label
                        htmlFor="Last Name"
                        className="text-600 font-semibold block mb-2"
                      >
                        Last Name <span className="pl-2 text-red-500">*</span>
                      </label>
                      <InputText
                        id="name"
                        name="lastName"
                        value={formik.values.lastName}
                        placeholder="Last Name"
                        className={styles.inputField1}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.lastName && formik.touched.lastName && (
                        <small className="text-red-500 block pt-1">
                          {formik.errors.lastName}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="grid md:pt-2">
                    <div className="col-12 md:col-6 sm:pt-2 ">
                      <label
                        htmlFor="email"
                        className="text-600 font-semibold block mb-2"
                      >
                        Work Email Address{" "}
                        <span className="pl-2 text-red-500">*</span>
                      </label>
                      <InputText
                        id="email"
                        name="email"
                        value={formik.values.email}
                        placeholder="Work Email Address"
                        className={styles.inputField1}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.email && formik.touched.email && (
                        <small className="text-red-500 block pt-1">
                          {formik.errors.email}
                        </small>
                      )}
                    </div>
                    <div className="col-12 md:col-6  ">
                      <label
                        htmlFor="Reporting Manager"
                        className="text-600 font-semibold block mb-2"
                      >
                        Reporting Manager{" "}
                      </label>

                      <Dropdown
                        name={`managerId`}
                        value={users.find(
                          (user) => user.id === formik.values.managerId
                        )}
                        onChange={(e) => {
                          formik.setFieldValue("managerId", e.value.id); // Set only the `name` field
                        }}
                        options={users}
                        optionLabel="name"
                        placeholder="Select Manager"
                        className="col-12 p-0"
                        onBlur={formik.handleBlur}
                        filter
                        filterValue={employeeFilter}
                        onFilter={(e) => setEmployeeFilter(e.filter)}
                        showClear
                      />
                      {formik.errors.managerId && formik.touched.managerId && (
                        <small className="text-red-500 block pt-1">
                          {formik.errors.managerId}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="grid md:pt-2">
                    <div className="col-12 md:col-6 ">
                      <label
                        htmlFor="Location"
                        className="text-600 font-semibold block mb-2"
                      >
                        Location<span className="pl-2 text-red-500">*</span>
                      </label>

                      <Dropdown
                        id="location"
                        name="location"
                        value={formik.values.location}
                        onChange={formik?.handleChange}
                        onBlur={formik?.handleBlur}
                        options={location}
                        optionLabel="label"
                        placeholder="Select Location"
                        className="col-12 p-0"
                      />
                      {formik.errors.location && formik.touched.location && (
                        <small className="text-red-500 block pt-1">
                          {formik.errors.location}
                        </small>
                      )}
                    </div>
                    <div className="col-12 md:col-6  ">
                      <label
                        htmlFor="Phone"
                        className="text-600 font-semibold block mb-2"
                      >
                        Phone
                      </label>
                      <InputText
                        id="Phone"
                        name="phoneNumber"
                        value={formik.values.phoneNumber}
                        placeholder="10 digits"
                        className={styles.inputField1}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.phoneNumber &&
                        formik.touched.phoneNumber && (
                          <small className="text-red-500 block pt-1">
                            {formik.errors.phoneNumber}
                          </small>
                        )}
                    </div>
                  </div>
                  <div className="grid md:pt-2">
                    <div className="col-12 md:col-6  ">
                      <label
                        htmlFor="address"
                        className="text-600 font-semibold block mb-2 "
                      >
                        Address
                      </label>
                      <InputText
                        id="address"
                        name="address"
                        value={formik.values.addresse}
                        placeholder="Address"
                        className={styles.inputField1}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.errors.address && formik.touched.address && (
                        <small className="text-red-500 block pt-1">
                          {formik.errors.address}
                        </small>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 w-100  pt-3 border-bottom-1  border-300">
                <span className="p-1 px-3 md:flex">
                  <h2 className=" font-medium m-0 text-600 pl-2 pr-3 ">
                    Project Details
                  </h2>
                  {formik.values.userProjectMapping.every(
                    (mapping) => !mapping.userTypeId
                  ) && (
                    <small className="text-red-500 pt-2 ">
                      ( At least one project type must be selected. )
                    </small>
                  )}
                </span>
              </div>
              <div className="col-12 w-100">
                <div className="form-for-add-project p-3">
                  {projectTypes.map((types, index) => {
                    return (
                      <div
                        key={types?.key}
                        className=" block align-item bg-white border-round-xl border-1 border-300 p-3 mt-5"
                        style={{
                          position: "relative",
                          zIndex: 2,
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          touchAction: "manipulation",
                        }}
                      >
                        <Checkbox
                          inputId={types.key}
                          id={types.key}
                          name={`userProjectMapping[${index}].userTypeId`}
                          style={{
                            pointerEvents: "auto",
                            touchAction: "manipulation",
                            marginRight: "8px",
                          }}
                          value={types?.key}
                          checked={
                            types?.key ===
                            formik.values?.userProjectMapping[index]?.userTypeId
                          }
                          onChange={(e) => {
                            formik.setFieldValue(
                              `userProjectMapping[${index}].userTypeId`,
                              e.target.checked ? e.target.value : ""
                            );
                          }}
                        />
                        <label
                          htmlFor={types.key}
                          className="ml-2"
                          style={{
                            cursor: "pointer",
                            fontSize: "16px",
                            userSelect: "none",
                            touchAction: "manipulation",
                          }}
                        >
                          {types.name}
                        </label>
                        {formik.values?.userProjectMapping[index]
                          ?.userTypeId && (
                          <>
                            {renderProjectDetails(
                              formik.values?.userProjectMapping[index],
                              types.name,
                              index
                            )}
                          </>
                        )}
                      </div>
                    );
                  })}
                  {/* //TODO: Show all validation at bottom */}
                  {/* {formik.errors.userProjectMapping &&
                    formik.touched.userProjectMapping && (
                      <div className="text-red-500 pt-3">
                        <small>
                          {typeof formik.errors.userProjectMapping === "string"
                            ? formik.errors.userProjectMapping
                            : "Please fix the validation errors above"}
                        </small>
                      </div>
                    )} */}
                </div>
              </div>
            </div>
          </div>
        </form>
      )}
    </React.Fragment>
  );
};
